export interface Gender {
  male: string;
  female: string;
}
